import { useEffect } from 'react'
import { useCourier } from '@trycourier/courier-react'

/**
 * Mounts inside the app after auth. Uses the useCourier hook to start
 * listening for real-time inbox updates once the user has signed in.
 */
export const CourierInitializer = () => {

    const courier = useCourier()

    useEffect(() => {

        const listener = courier.shared.addAuthenticationListener(({ userId }) => {
            if (userId) {
                courier.inbox.listenForUpdates()
            }
        })

        // If already signed in when this mounts, start listening immediately
        if (courier.shared.client) {
            courier.inbox.listenForUpdates()
        }

        return () => {
            courier.shared.removeAuthenticationListener(listener)
        }

    }, [])

    return null

}
